import React from 'react';
import DropdownFilterCell from './DropdownFilterCell';

const FieldFilterCell = (fields) => (props) => <DropdownFilterCell {...props} data={fields} />;

export default FieldFilterCell;
